export default __webpack_public_path__ + "static/media/ant5.1b9b8f6e.jpg";